import { combineReducers } from 'redux'
import createReducer from 'lib/reducers/createReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import { orderErrorsTypes } from 'actions/types'

const INITIAL_STATE = null

function dataHandler(state, action) {
  return action.payload ? action.payload : INITIAL_STATE
}

const dataReducer = createReducer(INITIAL_STATE, {
  [orderErrorsTypes.FETCH_ORDER_ERRORS_FULFILLED]: dataHandler,
  [orderErrorsTypes.CLEAR_FETCH_ORDER_ERRORS]: dataHandler,
})

const reducer = combineReducers({
  requestState: requestStateReducer(orderErrorsTypes.FETCH_ORDER_ERRORS),
  data: dataReducer,
})

export default reducer
